import { useNotify, useRefresh } from 'react-admin'

import { captureExceptionIfProduction } from 'helpers/utils'
import { cancelInvoice } from '../../../api/invoices'
import { FSMTransitionButton, XTransitionButtonProps } from './FSMTransitionButton'

export const InvoiceTransitionButton = ({
  record,
  transitionProps,
  classes,
  loading,
  setLoading,
}: XTransitionButtonProps) => {
  const notify = useNotify()
  const refresh = useRefresh()

  const handleSubmit = () => {
    setLoading(true)
    cancelInvoice(record.id)
      .then(() => {
        refresh()
        notify('Transition successful!', { type: 'success' })
        setLoading(false)
      })
      .catch((error) => {
        notify(error.response.data, { type: 'error' })
        captureExceptionIfProduction(error)
        setLoading(false)
      })
  }

  return (
    <FSMTransitionButton
      className={classes?.root}
      record={record}
      transitionProps={transitionProps}
      handleSubmit={handleSubmit}
      loading={loading}
    />
  )
}
